export default __webpack_public_path__ + "static/media/crypto-2.1347a90d.PNG";